import styles from 'styles/LoadingTable.module.scss';

const LoadingTable = () => {
    return (
        <span className={styles.loading_table}></span>
    );
};

export default LoadingTable;
